module.exports = __webpack_public_path__ + "img/colightnew.57419b87.png";